import React, { useLayoutEffect, useRef } from 'react'
import View from './view.js'
import { useDataSubmit } from 'Simple/Data.js'

export default function Logic(props) {
  let submit = useDataSubmit({
    context: 'payment',
    viewPath: props.viewPath,
  })
  let submitRef = useRef(submit)
  let onPaymentPageCallback = useRef(props.onPaymentPageCallback)

  useLayoutEffect(() => {
    submitRef.current = submit
    onPaymentPageCallback.current = props.onPaymentPageCallback
  }, [submit, props.onPaymentPageCallback])

  useLayoutEffect(() => {
    if (!props.locationId || !props.person?._id || !props.method) return

    submitRef.current({
      type: 'initialize',
      method: props.method,
      locationId: props.locationId,
      person: props.person,
      amount: props.amount || null,
      reusable: props.forceReuse ? true : undefined,
      reusableForBluefin: props.reusableForBluefin || false,
      onPaymentPageCallback: args => onPaymentPageCallback.current(args),
    })
  }, [
    props.method,
    props.locationId,
    props.person,
    props.amount,
    props.forceReuse,
  ])

  return <View {...props} />
}
